import Swal from 'sweetalert2';
import { DomainField } from '../../models/domain';

export async function promptCreateDomain(defaults?: {
    name?: string;
    field?: DomainField;
}): Promise<{ name: string; field?: DomainField } | null> {
    const safeName = (defaults?.name ?? '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;');
    const result = await Swal.fire({
        title: 'Crea record DNS',
        html: `
            <p class="swal2-html-container" style="margin: 0 0 8px;">
                Verranno creati il dominio società e lo shop (<code>shop.{nome}</code>).
            </p>
            <input id="dns-name" class="swal2-input" placeholder="sottodominio (es. acme)" value="${safeName}">
        `,
        showCancelButton: true,
        confirmButtonText: 'Crea record',
        cancelButtonText: 'Annulla',
        focusConfirm: false,
        preConfirm: () => {
            const name = (document.getElementById('dns-name') as HTMLInputElement | null)?.value?.trim();
            if (!name) {
                Swal.showValidationMessage('Inserisci il nome del record');
                return false;
            }
            return { name };
        }
    });

    if (!result.isConfirmed || !result.value) {
        return null;
    }

    return result.value as { name: string };
}
